import { render, staticRenderFns } from "./ModalNotification.vue?vue&type=template&id=5f9e0152&scoped=true"
import script from "./ModalNotification.vue?vue&type=script&lang=js"
export * from "./ModalNotification.vue?vue&type=script&lang=js"
import style0 from "./ModalNotification.vue?vue&type=style&index=0&id=5f9e0152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9e0152",
  null
  
)

export default component.exports